import { grey as muiGrey } from '@mui/material/colors'

const blue = {
  700: '#225CCC',
  600: '#2A73FF', // Primary CTA Mynt
  500: '#558FFF',
  400: '#80ABFF',
  300: '#AFCBFF',
  200: '#CCDDFF',
  100: '#eaf1ff',
} as const

const green = {
  700: '#0D8251',
  600: '#2ACC88',
  500: '#4DD49C',
  400: '#71DDB0',
  300: '#94E5C3',
  200: '#B8EED7',
  100: '#dff8ed',
} as const

// biome-ignore lint/correctness/noUnusedVariables: Will be moved to package
const red = {
  600: '#FF4752',
  500: '#F98080',
  400: '#F8B4B4',
  300: '#FBD5D5',
  200: '#FDE8E8',
  100: '#fdf2f2',
} as const

// Panda Alert
const amber = {
  700: '#88530F', // Review these colors with UX
  600: '#78530D',
  500: '#AB8131',
  400: '#FFC85F',
  300: '#FFD680',
  200: '#FFECC5',
  100: '#fff5e2',
} as const

const reminder = {
  600: '#7E3F6C',
  500: '#944F80',
  400: '#AF699B',
  300: '#D284BB',
  200: '#EFB6DE',
  100: '#ffddf5',
} as const

// We have adjusted our grey to match MUI in Figma, will be implemented soonTM
const grey = {
  ...muiGrey, // Since we dont have definitions of each gray hue, we need to spread in the ones from mui
  500: '#68676A',
  400: '#B3B3B4',
  300: '#C7C7C7',
  200: '#EEEEEE',
  100: '#F5F5F5',
  50: '#FCFCFC',
} as const

const white = 'rgb(255, 255, 255)'
const black = 'rgb(28, 27, 31)'

const background = {
  default: 'rgb(248, 248, 247)',
  paper: '#FFF', // Our cloud (rgb(251, 251, 252)) is too similar to the bg, so lets avvakta until UX decides
} as const

const text = {
  primary: black,
  secondary: grey[500],
} as const

const category = {
  Sand: '#ECBEA2',
  Pink: '#EDB0B9',
  Purple: '#DA89B3',
  Violet: '#BF9BE4',
  Blue: '#9CBDF4',
  Green: '#92D2A4',
  Moss: '#BDD292',
  AppleGreen: '#C0E3A4',
  Yellow: '#f8e67f',
} as const

export { amber, background, black, blue, category, green, grey, reminder, text, white }
